const VALID_VISUAL_STYLES = new Set(["original", "cs"]);

export const HIGURASHI_MYPAGE_PHASE_KEYS = [
  "1",
  "2-normal",
  "2-abnormal",
  "3-normal",
  "3-abnormal",
  "4-normal",
  "4-abnormal",
  "end",
];

export const normalizeHigurashiVisualStyle = (visualStyle) => {
  return VALID_VISUAL_STYLES.has(visualStyle) ? visualStyle : "original";
};

export const getHigurashiMyPagePhaseKey = ({ phase, isEnded }) => {
  if (isEnded) return "end";
  if (phase === "1-watanagashi") return "1";
  if (phase === "1") return "1";
  if (HIGURASHI_MYPAGE_PHASE_KEYS.includes(phase)) return phase;
  return "1";
};

export const getHigurashiMyPageDescriptionPhaseKey = ({ phase, isEnded }) => {
  if (isEnded) return "end";
  if (phase === "1-watanagashi") return "1-watanagashi";
  return getHigurashiMyPagePhaseKey({ phase, isEnded });
};

export const getHigurashiMyPageImageUrl = ({
  publicUrl = "",
  visualStyle,
  character,
  phaseKey,
}) => {
  const style = normalizeHigurashiVisualStyle(visualStyle);
  return `${publicUrl}/higurashi/mypage/${style}/${character}/${phaseKey}.webp`;
};

export const buildHigurashiMyPageCardData = ({
  stateData,
  basicState,
  character,
  visualStyle,
  t,
  publicUrl = "",
}) => {
  if (!stateData && !basicState) return null;

  const currentPhase = stateData?.stories?.current?.phase || basicState?.phase;
  const isEnded = Boolean(stateData?.is_ended || basicState?.is_ended);
  const phaseKey = getHigurashiMyPagePhaseKey({
    phase: currentPhase,
    isEnded,
  });
  const descriptionPhaseKey = getHigurashiMyPageDescriptionPhaseKey({
    phase: currentPhase,
    isEnded,
  });

  return {
    ...stateData,
    expire_at: stateData?.expire_at || basicState?.expire_at,
    is_expired: stateData?.is_expired ?? basicState?.is_expired ?? false,
    name: t(`character.${character}`),
    description: t(`myPage.phaseDescriptions.${character}.${descriptionPhaseKey}`, {
      defaultValue: "",
    }),
    eye_catch_url: getHigurashiMyPageImageUrl({
      publicUrl,
      visualStyle,
      character,
      phaseKey,
    }),
  };
};
